import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { TranslationsContentState } from '../TranslationsContent.state';
import { DropAreaWrapper } from './DropArea.style';
import { DropAreaState } from './DropArea.state';

type Props = {
    translationsContentState: TranslationsContentState;
};

export const DropArea = observer('DropArea', ({ translationsContentState }: Props) => {
    const [{ isUploading, isHighlighted, onSelectFilesHandle, onDragEnterHandle, onDropHandle, onDragLeaveHandle }] = useState(
        () => new DropAreaState({ translationsContentState })
    );

    return (
        <DropAreaWrapper>
            {isUploading ? (
                <div className='drop-area'>
                    <div className='spinner spinner--inline' />
                </div>
            ) : (
                <div
                    className={isHighlighted ? 'drop-area highlight' : 'drop-area'}
                    onDragEnter={onDragEnterHandle}
                    onDragLeave={onDragLeaveHandle}
                    onDragOver={onDragEnterHandle}
                    onDrop={onDropHandle}
                >
                    <form>
                        <p>Drag and drop CSV files here</p>
                        <input type='file' id='fileElem' multiple accept='.csv' onChange={onSelectFilesHandle} />
                        <label className='btn btn-add' htmlFor='fileElem'>
                            Browse...
                        </label>
                    </form>
                </div>
            )}
        </DropAreaWrapper>
    );
});

